import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import prevBtn from "./Icon Frame (1).png";
import nextBtn from "./Icon Frame (2).png";
import ConsoleItem from "./ConsoleItem";
import { consoles } from "./consoles";

const GameSwiper = ({ openModal }) => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const swiperRef = useRef(null);

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current.params.navigation.prevEl = prevRef.current;
            swiperRef.current.params.navigation.nextEl = nextRef.current;
            swiperRef.current.navigation.init();
            swiperRef.current.navigation.update();
        }
    }, []);

    return (
        <div className="game-swiper">
            <Swiper
                modules={[Navigation, Autoplay]}
                slidesPerView={1}
                loop={true}
                autoplay={{
                    delay: 10000,
                    disableOnInteraction: false,
                }}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
            >
                {consoles.map((console, index) => (
                    <SwiperSlide key={index}>
                        <ConsoleItem
                            name={console.name}
                            image={console.image}
                            gamepadsQuantity={console.gamepadsQuantity}
                            resolution={console.resolution}
                            ssdVolume={console.ssdVolume}
                            gameLibrary={console.gameLibrary}
                            Support={console.Support}
                            openModal={openModal}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
            <button ref={prevRef} className="custom-prev-c">
                <img className='arrow-btn' src={prevBtn} alt="prev" />
            </button>
            <button ref={nextRef} className="custom-next-c">
                <img className='arrow-btn' src={nextBtn} alt="next" />
            </button>
        </div>
    );
};

export default GameSwiper;
